import { InjectionToken } from "@angular/core";

export const ERROR_NOTIFICATION_SERVICE = new InjectionToken<ErrorNotificationServiceInterface>('error.notification.service');

export interface ErrorNotificationServiceInterface {
    showError(uuid: string, error: any): void
}